import { render, staticRenderFns } from "./OrganizationalTree.vue?vue&type=template&id=37b99a56&"
import script from "./OrganizationalTree.vue?vue&type=script&lang=js&"
export * from "./OrganizationalTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports